import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import debounce from 'lodash/debounce';
import * as React from 'react';
import { TextField } from '../../../../components/TextField';

export interface SearchFieldProps {
  item:
    | 'cards'
    | 'charge points'
    | 'groups'
    | 'installers'
    | 'jobs'
    | 'locations'
    | 'logs'
    | 'organisations'
    | 'sessions'
    | 'users';

  /** DO NOT SET - Provided by the table props. */
  dataManager: { changeSearchText: (text: string) => void; searchText: string };
  /** DO NOT SET - Provided by the table props. */
  search: boolean;
  /** DO NOT SET - Provided by the table props. */
  onSearchChanged: (newSearchText: string) => void;
}

export const SearchField: React.FC<SearchFieldProps> = ({ dataManager, item, onSearchChanged, search }) => {
  const [searchText, setSearchText] = React.useState<string>(dataManager.searchText);

  const applySearch = debounce((text: string) => {
    dataManager.changeSearchText(text);
    onSearchChanged(text);
  }, 300);

  const handleSearchChange = React.useCallback(
    (text: string) => {
      setSearchText(text); // Update local state immediately for responsive UI
      applySearch(text); // Debounce the expensive operation
    },
    [applySearch],
  );

  if (!search) {
    return null;
  }

  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="inherit" fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton disabled={!searchText} onClick={() => handleSearchChange('')} size="small">
              <ClearIcon color="inherit" fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      onChange={(event) => handleSearchChange(event.target.value)}
      placeholder={item ? `Search ${item}...` : 'Search...'}
      type="text"
      value={searchText}
    />
  );
};
